import { render, staticRenderFns } from "./GameListDisplay.vue?vue&type=template&id=261c710e&"
import script from "./GameListDisplay.vue?vue&type=script&lang=js&"
export * from "./GameListDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports